/*
 * Request Consultation Hero
 */
export const REQUEST_CONSULTATION_HERO_TITLE = `Request A Consultation`;

export const REQUEST_CONSULTATION_HERO_DESC = `Every dream home starts with a conversation. Request a free consultation with Craig Hays at Cornerstone Homes in Claremore, OK to discuss your custom home, renovation, or design project. Take the first step towards creating the home you've always envisioned.`;
